var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('TabelaCobrancas',{ref:"tabelaCobrancas"})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"display-title-page"},[_c('div',{staticClass:"ml-2"},[_c('div',{staticClass:"title mb-1"},[_vm._v("Tabela de cobranças")]),_c('div',{staticClass:"caption mb-3"},[_vm._v(" Página que irá conter todas as cobranças geradas dentro do sistema ")])])])
}]

export { render, staticRenderFns }